import { useState, useEffect } from 'react';
import BreadcrumbHeader from 'ui-component/BreadcrumbHeader';
import { IconEdit } from '@tabler/icons';
import Card from 'ui-component/cards/Card'
import { FetchAllMasterEmailTemplate, UpdateMasterEmailToggleTemplateForm } from 'api';
import { useNavigate, useParams } from "react-router-dom";
import Loading from 'views/Loading';
import AsyncTableListing from 'ui-component/AsyncTableListing';
import Clickable from 'utils/Clickable';
import { Grid, Box, Tooltip, Switch, Typography } from '@mui/material';
import TextField from 'ui-component/TextField';
import { useTheme } from '@mui/material/styles';
import { toast, ToastContainer } from 'react-toastify';
import CustomButton from 'ui-component/CustomButton';


const columns = [

  {
    label: 'Title',
    minWidth: 200,
    align: 'left',
    type: 'name',
    trim: 60,
  },
  {
    label: 'Type',
    minWidth: 100,
    align: 'left',
    type: 'eventType'
  },
  {
    label: 'Created At',
    minWidth: 120,
    align: 'left',
    type: 'createdAt'
  },
  {
    label: 'Created By',
    minWidth: 120,
    align: 'left',
    type: 'createBy',
    link: true,
  },
  {
    label: 'Actions',
    minWidth: 80,
    align: 'right',
    type: 'actions'
  },
];

export default function ChecklistListing() {

  const [search, setSearch] = useState('');
  const [stage, setStage] = useState('');
  const [searchStatus, setSearchStatus] = useState(false);
  const [page, setPage] = useState(1);
  const [reset, setreset] = useState(false)
  const navigate = useNavigate();
  const [sort, setSort] = useState(-1);
  const [limit, setLimit] = useState(20);
  const theme = useTheme();

  const { isLoading: isAllMasterTemplateLoading, isRefetching: isAllMasterTemplateRefetching, data: AllMasterTemplate, refetch: refetchListing } = FetchAllMasterEmailTemplate()
  const {
    mutateAsync: UpdateMasterTemplate,
    isLoading: isLoadingUpdateUpdateMasterTemplate,
    status: UpdateMasterTemplateStatus,
    error: UpdateMasterTemplateError
  } = UpdateMasterEmailToggleTemplateForm();

  const CreatedBy = ({ row }) => {
    return row?.createdBy?.name;
  }
  useEffect(() => {
    refetchListing()
  }, [reset])


  const StartupActions = ({ row }) => {
    const handleToggle = async () => {
      try {
        const response = await UpdateMasterTemplate({ id: row._id });
        toast.success(response?.data?.message || 'Toggled successfully');
        refetchListing();
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Toggle failed');
      }
    };
    return (
      <div style={{ display: 'flex', justifyContent: 'right', columnGap: "12px", alignItems: "center" }}>
        <Tooltip title="Active/Inactive">
          <div>
            <Switch checked={row?.active || false} onChange={handleToggle} />
          </div>
        </Tooltip>
        <Clickable style={{ display: 'flex', alignItems: 'right' }} onClick={() => navigate(`/emailTemplate/edit-emailTemplate/${row._id}`)}>
          <Tooltip title="Edit">
            <div style={{ display: 'flex', alignItems: 'right' ,color:'rgb(68, 76, 231)'}}>
              <IconEdit stroke={1.5} size="1.4rem" />
            </div>
          </Tooltip>
        </Clickable>
      </div>
    );
  }
  return (
    <>
      {/* <Box sx={{ width: '100%' }}>
                <BreadcrumbHeader title="Email Templte" shouldGoBack={false} />
            </Box> */}
      <ToastContainer />
      <div className='custom-menu-block view-investor-block'>
      {/* <Card style={{ padding: "32px 32px 24px 32px" }}> */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', paddingRight: '1rem' }}>
          <Typography sx={{ fontSize: '1.25rem', letterSpacing: '0.00938em', lineHeight: '30px', fontFamily: 'Lato, sans-serif !important', fontWeight: '700', marginBottom: '1rem', }}> Email Template</Typography>
        </Box>
        <Grid container direction="row" columnSpacing={1} rowSpacing={2} mb={1} mt={0}>
          <Grid item sm={3} xs={8}>
            <TextField
              label="Search"
              value={search}
              autoComplete='off'
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  refetchListing()
                  if (search) {
                    setSearchStatus(true)
                  }
                }
              }}
              onChange={(event) => {
                setSearch(event.target.value)
                setSearchStatus(false)
              }}
              size="small"
              sx={{
                '& input': {
                  background: theme.palette.background.paper,
                },
                '& input:valid + fieldset': {
                  borderColor: theme.palette.secondary[200],
                  borderWidth: 0.5,
                },
                '& input:valid:hover + fieldset': {
                  borderColor: '#4050b5',
                  borderWidth: 1,
                },
                '& input:valid:focus + fieldset': {
                  borderColor: '#4050b5',
                  padding: '4px !important',
                  borderWidth: 1,
                  borderLeftWidth: 6,
                },
              }}
            />
          </Grid>
          <Grid item sm={2} xs={4} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} className='search-btn'>
            <CustomButton
              size="medium"
              sx={{ height: '40px', textAlign: 'center', display: 'block' }}
              color={(searchStatus && search !== '') ? [theme.palette.error.dark, theme.palette.error.main] : [theme.palette.secondary[800], theme.palette.secondary.main]}
              onClick={() => {
                if (searchStatus && search !== '') {
                  setSearch('')
                  setStage('')
                  setreset(!reset)
                } else {
                  refetchListing()
                }
                setSearchStatus((oldVal) => !oldVal)

              }}
              fullWidth
            >
              {(searchStatus && search !== '') ? "Reset" : "Search"}
            </CustomButton>
          </Grid>
          <Grid item sm={7} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <CustomButton size="medium" onClick={() => navigate(`/emailTemplate/create-emailTemplate`)} sx={{ height: '40px' }}>Create</CustomButton>
          </Grid>
        </Grid>
        {isAllMasterTemplateLoading ? <Loading />
          : <AsyncTableListing
            title=""
            columns={columns}
            data={AllMasterTemplate.data}
            actions={StartupActions}
            page={page}
            setPage={setPage}
            count={AllMasterTemplate.count}
            sort={sort}
            setSort={setSort}
            limit={limit}
            setLimit={setLimit}
            cutomLink={CreatedBy}
            pagination={false}

          />}
      {/* </Card> */}
      </div>
    </>
  )
}

